module.exports = __webpack_public_path__ + "images/b8993c43c76edf674eb4746d5f384fb7.png";